import { Injectable } from "@angular/core";
import { ReplacementRule, Replacer } from "@main/reporting.v3/core/regex/regex-utility.models";

@Injectable()
export class RegexUtilityService {
    // Escapes a given text to be able to convert it into a regex pattern.
    public escapeRegex(pattern: string): string {
        return pattern.replace(/[.*+?^${}()|\[\]\\]/g, "\\$&");
    }

    // Escapes a given text list to be able to convert its elements into regex patterns.
    public escapeRegexes(patterns: string[]): string[] {
        return patterns.map(pattern => this.escapeRegex(pattern));
    }

    // Applies a series of replacement rules to a given text.
    public applyReplacementRules(text: string, rules: ReplacementRule[]): string {
        return rules.reduce((current: string, rule: ReplacementRule): string =>
            typeof rule.replacer === "string"
                ? current.replace(rule.pattern, rule.replacer as string)
                : current.replace(rule.pattern, rule.replacer as Replacer), text);
    }
}